export default "__VITE_ASSET__BU$q39PI__"